import { ref, onBeforeMount, type Ref } from 'vue'
import { callSimulationApi } from '@/composables/useFinancoApi'
import { mapRefreshedHeroExample } from '@/extensions/utils/common/hero/hero.mapper'
import { mapRefreshUiOffersProps } from '@/extensions/utils/common/offerTipsBlock/offerTipsBlock.mapper'
import type { MappedProductHubType } from '@/extensions/productHub/productHub.type'
import type { MappedProductType } from '@/extensions/product/product.type'
import type { MappedSubProductType } from '@/extensions/subProduct/subProduct.type'
import type { UiHeroProps, UiOfferTipsProps } from '@afs/design-system'
import type { MappedHomepageType } from '@/extensions/homepage/homepage.type'

interface useSimulationValues {
  heroProps: Ref<UiHeroProps | undefined>
  offerTipsBlocProps: Ref<UiOfferTipsProps | undefined>
  additionnalLegalProps: Ref<string | undefined>
}
export function useSimulation(
  data: MappedProductType | MappedProductHubType | MappedSubProductType | MappedHomepageType | undefined,
): useSimulationValues {
  const heroProps = ref<UiHeroProps | undefined>(data?.hero)
  const offerTipsBlocProps = ref<UiOfferTipsProps | undefined>(undefined)
  const additionnalLegalProps = ref<string | undefined>(data?.legalNoticeBlock.addtionalLegalNotice)

  const updateSimulationValues = async () => {
    try {
      if (data && data.exampleSimulationData) {
        const simulationData = await callSimulationApi(
          data.exampleSimulationData.purchaseAmount,
          data.exampleSimulationData.nbPayments,
          data.exampleSimulationData.project_type,
        )

        if (simulationData) {
          const refreshedExample = mapRefreshedHeroExample(data.exampleSimulationData, simulationData.simulation)
          heroProps.value = {
            ...data.hero,
            loanExample: refreshedExample,
          }
          //OfferTipsBlock n'exite pas si MappedProductHubType
          if ('offerTipsBlock' in data) {
            if (data.offerTipsBlock) {
              const refreshedOffersProps = mapRefreshUiOffersProps(simulationData.simulation)
              offerTipsBlocProps.value = {
                ...data.offerTipsBlock,
                offer: refreshedOffersProps,
              }
            }
          }
        }
        if (data.legalNoticeBlock.addtionalLegalNotice) {
          additionnalLegalProps.value = simulationData.legalNoticeHtml
        }
      }
    } catch (error) {
      // Do nothing, keep previous value
    }
  }

  onBeforeMount(updateSimulationValues)

  return { heroProps, offerTipsBlocProps, additionnalLegalProps }
}
